import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import Agents from '../../../../../../views/Threat/Agents/Agents';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/agents/{-$id}/')({
  component: Agents,
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.AgentDashboard];
    context.validatePermissions({ isAllowed, preload });
  },
});
